import './style/index.js';

import _Guide from './Guide';

export type { GuideCrossProps, GuideProps, TdGuideStepProps } from './Guide';
export * from './type';

export const Guide = _Guide;
export default Guide;
